<template>
  <!-- menu-provider 提供 $xxMenu 的注入 -- 相当于一个 mini state -->
  <xx-menu-provider class="page-content-outer">
    <div id="layout-iframe-nav">
      <xx-menu-header />
    </div>
    <div class="page-content-slot">
      <!-- 对于 pc 页面来说好像只需要菜单就行了？不需要下面的 tab-view -->
      <div id="layout-iframe-second-menu-outer">
        <xx-menu-sidebar v-if="$xxPlatform.accountTypeByPath === 0" />
        <RenxiaoAsideMenu v-else />
      </div>
      <xx-tab-view> </xx-tab-view>
    </div>
  </xx-menu-provider>
</template>

<script>
import XxTabView from "./TabView/index";
import {
  XxMenuProvider,
  XxMenuHeader,
  XxMenuSidebar,
  RenxiaoAsideMenu,
} from "./Menu";
import { detectDeviceType } from "../utils/tools";

export default {
  components: {
    XxTabView,
    XxMenuHeader,
    XxMenuSidebar,
    XxMenuProvider,
    RenxiaoAsideMenu,
  },
  inject: ["$xxPlatform"],
  data() {
    return {
      isMobile: detectDeviceType() === "Mobile",
    };
  },
};
</script>

<style lang="scss" scoped>
body {
  box-sizing: border-box;
}

:root,
* {
  box-sizing: border-box;
}

.page-content-outer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  .page-content-slot {
    flex: 1;
    display: flex;
    overflow: hidden;
    &.border-bottom {
      border-bottom: 40px solid #3a404d; // 留出移动端底部安全区
    }
  }
}
</style>
